/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Voice_Playback_HintInputs */

const en_settings_v2_voice_playback_hint = /** @type {(inputs: Settings_V2_Voice_Playback_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice, speed, reader behaviour`)
};

const es_settings_v2_voice_playback_hint = /** @type {(inputs: Settings_V2_Voice_Playback_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz, velocidad, lector`)
};

/**
* | output |
* | --- |
* | "Voice, speed, reader behaviour" |
*
* @param {Settings_V2_Voice_Playback_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_voice_playback_hint = /** @type {((inputs?: Settings_V2_Voice_Playback_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Voice_Playback_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_voice_playback_hint(inputs)
	return en_settings_v2_voice_playback_hint(inputs)
});